import { message } from "antd";
import { reportTransactionRequest } from './../api/transaction';


export const handleTransactionAction = async (action, transactionReference) => {
  if (!action || !transactionReference) return;

  message.destroy(); // Clear any existing messages before showing a new one

  switch (action) {
    case "authorize_refund":
      await handleAuthorizeRefund(transactionReference);
      break;
    default:
      message.warning("Unknown action.");
  }
};


const handleAuthorizeRefund = async (transactionReference) => {
  try {
    message.loading("Authorizing refunds... Please wait.");
    const response = await reportTransactionRequest(transactionReference);
    message.destroy();
    message.success(response?.data?.message || "Refunds authorized successfully.");
  } catch (err) {
    message.destroy();
    message.error(err?.message || "Failed to authorize refunds.");
  }
};
